module.exports = __webpack_public_path__ + "media/invoiceba.c7234a32.mp4";